import Vue from 'vue';
import { UserVuetifyPreset } from 'vuetify';
import Vuetify from 'vuetify/lib';

const opts: Partial<UserVuetifyPreset> = {
  theme: {
    dark: false,
    // disable: true, TODO: Enable this setting
    options: {
      customProperties: true,
      variations: false
    }
  }
};

Vue.use(Vuetify);

export default new Vuetify(opts);
